import axios from 'axios';

export const getBooks = () => {
	return axios.get(`/books/books.json?${Math.random*9999}`).then((res) => {
		return res.data;
	});
};
